export function deleteMaster(data) {
    return new Promise((resolve, reject) => {
        let { deleteMasterRequest, deleteMasterError, deleteMasterResult } = this.props

        this.doAction(
            this.WEB_REQUEST_URL + 'delete_master',
            this.createBundle(
                'delete_master',
                { master: data },
                this.POST,
                deleteMasterRequest,
                (result) => {
                    deleteMasterResult(result)
                    resolve(result)
                },
                (error) => {
                    deleteMasterError(error)
                    reject(error)
                }
            )
        )
    })
}
